import React from 'react';

const LoadingTest = () => {
  return (
    <div className='mt-5 sm:mt-10 min-h-screen'>
      <div className="rounded-md p-4 sm:w-[950px] mx-auto">
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-3 bg-slate-200 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                <div className="h-3 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-3 bg-slate-200 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                <div className="h-3 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-3 bg-slate-200 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                <div className="h-3 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="rounded-md p-4 sm:w-[950px] mx-auto">
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-3 bg-slate-200 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                <div className="h-3 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-3 bg-slate-200 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                <div className="h-3 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-3 bg-slate-200 rounded"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                <div className="h-3 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export { LoadingTest };
